import { fetchPermissionList } from '@/api/sys/auth'
const state = {
  permissions: [],
}
const mutations = {
  SET_PERMISSIONS: (state, permissions) => {
    if(permissions && JSON.stringify(permissions) != '{}'){
      localStorage.setItem("permissions", JSON.stringify(permissions['permission']))
    }else{
      state.permissions = []
    }
  },
}
const actions = {
  // 获取权限
  GetPermissions({ commit, state }) {
    return new Promise((resolve, reject) => {
      fetchPermissionList(state.token).then(response => {
        if (response.data.code === '200') {
          const permissions = response.data.data
          commit('SET_PERMISSIONS', permissions)
          resolve()
        }else{
          reject(response.data.data)
        }

      }).catch(error => {
        reject(error)
      })
    })
  },
  ResetPermissions({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_PERMISSIONS', {})
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js